module.exports = __webpack_public_path__ + "static/img/pinpai-21.f65e5ed5.png";